import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Alert",
  [
    [
      "path",
      {
        d: "M21.79,4.01l.28-.28-1.45-1.45-2.44,2.44c-1.67-1.33-3.77-2.12-6.06-2.12C6.74,2.59,2.37,6.96,2.37,12.34c0,2.29.8,4.39,2.12,6.06l-2.16,2.16-.28.28,1.45,1.45,2.42-2.42c1.69,1.39,3.84,2.22,6.19,2.22,5.38,0,9.75-4.37,9.75-9.75,0-2.35-.84-4.51-2.22-6.19l2.14-2.14ZM5.74,17.15c-1.01-1.34-1.62-3-1.62-4.81,0-4.41,3.59-8,8-8,1.81,0,3.47.61,4.81,1.62l-11.19,11.19ZM18.4,7.4c1.08,1.36,1.72,3.08,1.72,4.94,0,4.41-3.59,8-8,8-1.87,0-3.58-.65-4.94-1.72l11.22-11.22Z",
      },
    ],
  ],
  "currentColor"
);
